module.exports = __webpack_public_path__ + "assets/img/order_8.fda088bd.svg";